import _extends from "@babel/runtime/helpers/extends";

/*
 * @Author: wangshengqiang
 * @Date: 2021-04-20 16:09:49
 * @LastEditTime: 2022-01-12 16:50:01
 * @LastEditors: wangshengqiang
 * @Description: 日期选择
 */
import React from 'react';
import moment from 'moment';
import FormItem from '@/baseComponents/FormItem';
import DateSelect from '@/baseComponents/DateSelect';
import { getDateRange } from './tool'; // limit:
// begin: (2) ["28", "D"]
// end: (2) [18, "Y"]

export default function RowDate(props) {
  const {
    disabled,
    attrs,
    formKey,
    label,
    min = moment().subtract(80, 'years').format('YYYY-MM-DD'),
    max = moment().subtract(18, 'days').format('YYYY-MM-DD'),
    isRequired,
    isBenefitFactor,
    isPremiumFactor,
    initialValue,
    remark = {}
  } = props;
  const {
    limit,
    display = {}
  } = attrs;
  const {
    placeholder
  } = display || {};
  const dateRange = getDateRange(limit, min, max);
  let _initialValue = initialValue;

  if (display.hasDefaultValue && display.defaultValue && !initialValue) {
    const str = JSON.parse(display.defaultValue);
    _initialValue = moment(str).format('YYYY-MM-DD');
  }

  const formItemProps = {
    name: formKey,
    label,
    remark,
    fieldOption: {
      rules: [{
        required: isRequired,
        message: '请选择'
      }],
      isBenefitFactor,
      isPremiumFactor,
      initialValue: _initialValue
    }
  };
  return /*#__PURE__*/React.createElement(FormItem, _extends({}, props, formItemProps), /*#__PURE__*/React.createElement(DateSelect, _extends({
    title: "\u9009\u62E9\u65E5\u671F",
    placeholder: placeholder,
    mode: "date",
    disabled: disabled
  }, dateRange)));
}